<template>
  <div class="mobile-root">
    <div class="bg-wrap">
      <!-- <img class="bg" :src="img" > -->
      <section class="my-pannel">
        <div class="main">
          <Form @submit="onSubmit" :label-width="60">
            <Field
              v-model="username"
              size="large"
              name="mobile"
              label="手机号"
              type="tel"
              placeholder="请输入手机号"
              :rules="[{ pattern, message: '请输入正确的手机号' }]"
            />
            <Field
              v-model="code"
              size="large"
              name="code"
              center
              clearable
              label="验证码"
              placeholder="请输入短信验证码"
            >
              <template #button>
                <Button v-if="!isShowSS" size="small" @click="onGetCode" color="linear-gradient(90deg,#5fdded 0,#00bcd4 100%)" native-type="button">获取验证码</Button>
                <div class="count-down" v-if="isShowSS">
                  <countDown :time="time" format='ss' @finish="finishHandle" ref="countdown" /> 秒
                </div>
              </template>
            </Field>
            <div style="padding: 16px;">
              <Button round block color="linear-gradient(90deg,#5fdded 0,#00bcd4 100%)" native-type="submit">
                提交
              </Button>
            </div>
          </Form>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { http } from 'utils/'
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      img:require('../../assets/images/bg.png'),
      username:"",
      code:"",
      isShowSS:false,
      time: 30 * 1000,
      pattern: /^1[23456789]\d{9}$/
    }
  },
  created() {
    document.title = '个人中心'
  },
  methods:{
    async postHandle(data) {
      const res = await http({
        url:'/api/update_mobile/',
        method:'POST',
        data:{
          ...data,
        },
        headers: {
          'content-type': 'application/json',
          "Authorization": `Bearer ${this.getToken()}`
        }
      })
      if(res) {
        // this.$router.push('/profile')
        this.$emit('popupHandle')
      }
      console.log(res)
    },
    async getCode() {
      const res = await http({
        url:'/api/get_code/',
        params:{
          mobile:this.username
        },
        headers: {
          'content-type': 'application/json',
          "Authorization": `Bearer ${this.getToken()}`
        }
      })
      console.log(res)
    },
    onSubmit(values) {
      this.postHandle(values)
    },
    onGetCode() {
      if( !this.pattern.test(this.username) ) return
      this.isShowSS = true
      this.getCode()
    },
    getToken() {
      const token = Cookies.get('JWT')
      if (token) return token
      else return false
    },
    finishHandle() {
      this.isShowSS = false
    },
    closeHandle() {
      if(this.$refs.countdown) this.$refs.countdown.reset()
      this.isShowSS = false
      this.username = ''
      this.code = ''
    }
  }
}
</script>

<style lang="less" scoped>
.bg-wrap{
  // height: 2rem;
  .bg{
    width: 100%;
    height: 100%;
  }
  .count-down{
    width: 76px;
    height: 30px;
    // color: aqua;
    display: flex;
    align-items: center;
    justify-content: center;
    .van-count-down{
      color: #969799;
    }
  }
  .my-pannel{
    // margin: 20px 0;
    border-radius: 12px 12px 12px 12px;
    box-shadow: 0 2px 16px 0 rgba(97,97,97,0.1);
    position: relative;
    overflow: hidden;
    .main{
      background-color: #fff;
    }
  }
}
</style>